/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

export enum AvailableActions {
    CREATE = 'CREATE',
    REJECT = 'REJECT',
    SEND = 'SEND',
    SOLVE = 'SOLVE',
    DONE = 'DONE',
    UNDONE = 'UNDONE',
    CANCEL = 'CANCEL',
    REJECT_SOLUTION = 'REJECT_SOLUTION',
    SEND_SOLUTION = 'SEND_SOLUTION'
}
